/* 1Luxury Concierge request-state handoff: fragment/session payload plus legacy query compatibility. */
(function () {
  'use strict';

  var config = window.OneLuxuryRequestStateConfig;
  if (!config || config.pageHandle !== '1luxury-concierge') return;

  var STATE_KEY = 'one_luxury_request_state_v1';
  var LEGACY_KEY = 'lux_private_invoice_payload';
  var REQUEST_KEYS = [
    'invoice_request', 'appointment_request', 'product', 'handle', 'product_id', 'variant',
    'price', 'quantity', 'qty', 'options', 'custom', 'summary', 'url', 'metal', 'color',
    'diamonds', 'stone', 'size', 'length', 'delivery_date', 'service_format', 'preferred_contact',
    'source'
  ];

  function text(value, limit) {
    return String(value || '')
      .replace(/[\u0000-\u001F\u007F<>]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, limit || 300);
  }

  function identifier(value) {
    value = text(value, 32);
    return /^\d{1,32}$/.test(value) ? value : '';
  }

  function handle(value) {
    value = text(value, 160).toLowerCase();
    return /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(value) ? value : '';
  }

  function quantity(value) {
    value = text(value, 8);
    return /^(?:[1-9]|[1-9]\d{1,2})$/.test(value) ? value : '';
  }

  function price(value) {
    value = text(value, 32);
    return /^\$?[\d,]+(?:\.\d{1,2})?$/.test(value) ? value : '';
  }

  function productUrl(value) {
    if (!value) return '';
    try {
      var url = new URL(value, window.location.origin);
      if (url.origin !== window.location.origin || !/^\/products\/[a-z0-9][a-z0-9-]*$/i.test(url.pathname)) return '';
      var variant = identifier(url.searchParams.get('variant'));
      return url.origin + url.pathname + (variant ? '?variant=' + encodeURIComponent(variant) : '');
    } catch (error) {
      return '';
    }
  }

  function safeState(params) {
    var state = {};
    var value;

    value = text(params.get('product'), 300); if (value) state.product = value;
    value = handle(params.get('handle')); if (value) state.handle = value;
    value = identifier(params.get('product_id')); if (value) state.product_id = value;
    value = identifier(params.get('variant')); if (value) state.variant = value;
    value = price(params.get('price')); if (value) state.price = value;
    value = quantity(params.get('quantity') || params.get('qty')); if (value) state.quantity = value;
    value = text(params.get('options'), 1000); if (value) state.options = value;
    value = text(params.get('custom'), 1000); if (value) state.custom = value;
    value = text(params.get('summary'), 1600); if (value) state.summary = value;
    value = productUrl(params.get('url')); if (value) state.product_url = value;
    ['metal', 'color', 'diamonds', 'stone', 'size', 'length', 'delivery_date', 'service_format', 'preferred_contact', 'source'].forEach(function (key) {
      value = text(params.get(key), 160);
      if (value) state[key] = value;
    });
    if (params.get('invoice_request') === 'true') state.invoice_request = 'true';
    if (params.get('appointment_request') === 'true') state.appointment_request = 'true';
    return state;
  }

  function fragmentState() {
    var hash = new URLSearchParams(window.location.hash.replace(/^#/, ''));
    var type = text(hash.get('ol-request'), 32).toLowerCase();
    if (type === 'invoice') return { invoice_request: 'true' };
    if (type === 'appointment') return { appointment_request: 'true' };
    return {};
  }

  function hasValues(object) {
    return Object.keys(object).length > 0;
  }

  function requestQueryPresent(params) {
    return REQUEST_KEYS.some(function (key) { return params.has(key); });
  }

  function trackingQuery(params) {
    var result = new URLSearchParams();
    params.forEach(function (value, key) {
      if (/^utm_/i.test(key) || /^(gclid|dclid|fbclid|msclkid|srsltid)$/i.test(key)) result.set(key, value);
    });
    return result;
  }

  function addLegacyFallbackRobots() {
    var robots = document.querySelector('meta[name="robots"]');
    if (!robots) {
      robots = document.createElement('meta');
      robots.name = 'robots';
      document.head.appendChild(robots);
    }
    robots.content = 'noindex,follow';
    robots.setAttribute('data-one-luxury-legacy-request-fallback', 'true');
  }

  function store(state) {
    try {
      sessionStorage.setItem(STATE_KEY, JSON.stringify(state));
      sessionStorage.setItem(LEGACY_KEY, JSON.stringify({
        invoice_request: state.invoice_request || '',
        appointment_request: state.appointment_request || '',
        product_title: state.product || '',
        product_handle: state.handle || '',
        product_id: state.product_id || '',
        variant_id: state.variant || '',
        product_price: state.price || '',
        quantity: state.quantity || '1',
        selected_options: state.options || '',
        custom_fields: state.custom || '',
        product_url: state.product_url || '',
        invoice_summary: state.summary || ''
      }));
    } catch (error) {
      /* Session storage can be unavailable; the in-memory state below remains usable. */
    }
  }

  function clearStoredState() {
    try {
      sessionStorage.removeItem(STATE_KEY);
      sessionStorage.removeItem(LEGACY_KEY);
    } catch (error) {
      /* No action is needed when session storage is unavailable. */
    }
  }

  var params = new URLSearchParams(window.location.search);
  var hasLegacyRequest = requestQueryPresent(params);
  var fromQuery = hasLegacyRequest ? safeState(params) : {};
  var fromFragment = fragmentState();
  var state = Object.assign({}, fromQuery, fromFragment);

  if (!hasValues(state)) {
    clearStoredState();
    window.OneLuxuryRequestState = {};
    return;
  }

  window.OneLuxuryRequestState = state;
  store(state);

  if (hasLegacyRequest) {
    /* Compatibility-only fallback: this is intentionally JavaScript-only, never the primary private-invoice SEO control. */
    addLegacyFallbackRobots();
    var tracking = trackingQuery(params).toString();
    history.replaceState(history.state, '', config.cleanPath + (tracking ? '?' + tracking : '') + window.location.hash);
  }

  document.dispatchEvent(new CustomEvent('one-luxury-request-state-ready'));

  document.addEventListener('one-luxury-request-state-hydrated', function () {
    if (window.location.hash) history.replaceState(history.state, '', window.location.pathname + window.location.search);
    clearStoredState();
  }, { once: true });
})();
